module.exports = __webpack_public_path__ + "static/loader-3dcbcaae28a0da2e1ddc63d14d89b996.gif";